export default __webpack_public_path__ + "static/media/trashBlack.e954c2ee.svg";